module.exports = __webpack_public_path__ + "assets/img/eight.db4f6da2.png";